/** The chrome every screen wears: title bar with an info strip, a body, the key-hint bar. */

import { el } from '../dom';
import type { KeyHint } from './keyHints';
import { keyHintBar, NAV_HINTS } from './keyHints';

export interface Frame {
  /** The screen element (`Screen.el`). */
  el: HTMLElement;
  /** Right-hand side of the title bar: RP, codename, step counters. */
  info: HTMLElement;
  /** Where the screen puts its content: a flex row. */
  body: HTMLElement;
}

/** `kind` becomes the class `menu-screen-<kind>`, the hook for the screen's own stylesheet. */
export function frame(kind: string, title: string, hints: readonly KeyHint[] = NAV_HINTS, note = ''): Frame {
  const root = el('div', `menu-screen menu-screen-${kind}`);
  root.setAttribute('role', 'region');
  root.setAttribute('aria-label', title);
  const head = el('div', 'menu-head');
  const info = el('div', 'menu-head-info');
  head.append(el('div', 'menu-head-title', title), info);
  const body = el('div', 'menu-body');
  root.append(head, body, keyHintBar(hints, note));
  return { el: root, info, body };
}
